// Auto generated file, do not manually modify!
// com.hotpads.zcalendar.client.enums.ActionMetadataEntryPoint

export enum ActionMetadataEntryPoint {
  CALENDAR_SETTINGS = 'CALENDAR_SETTINGS',
  NEW_LISTING = 'NEW_LISTING',
  REACTIVATION_LISTING = 'REACTIVATION_LISTING',
  UNKNOWN = 'UNKNOWN',
  WIZARD = 'WIZARD',
}

export const ActionMetadataEntryPoint_values = [
  ActionMetadataEntryPoint.CALENDAR_SETTINGS,
  ActionMetadataEntryPoint.NEW_LISTING,
  ActionMetadataEntryPoint.REACTIVATION_LISTING,
  ActionMetadataEntryPoint.UNKNOWN,
  ActionMetadataEntryPoint.WIZARD,
] as const;
